module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slide",
    staticClass: "slide",
    style: ({
      height: _vm.itemHeight + 'px',
      width: _vm.width
    })
  }, [_c('div', {
    ref: "slidecontent",
    staticClass: "slide-content animate-hack",
    style: ({
      width: _vm.fullWidth + 'px'
    })
  }, [_vm._l((_vm.items), function(item) {
    return _c('carousel-item', {
      style: ({
        width: _vm.itemWidth + 'px',
        height: _vm.itemHeight + 'px'
      }),
      attrs: {
        "imgUrl": item.imgUrl
      }
    })
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "slide-btns"
  }, _vm._l((_vm.items), function(item, key, index) {
    return _c('button', {
      staticClass: "slide-btn",
      class: [key === _vm.currentIndex ? 'slide-btn-current' : '']
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-384dc875!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carousel.vue
// module id = 241
// module chunks = 15